import { render, staticRenderFns } from "./PaginatorFooter.vue?vue&type=template&id=583fdf66&scoped=true"
import script from "./PaginatorFooter.vue?vue&type=script&lang=js"
export * from "./PaginatorFooter.vue?vue&type=script&lang=js"
import style0 from "./PaginatorFooter.vue?vue&type=style&index=0&id=583fdf66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583fdf66",
  null
  
)

export default component.exports